import type { IconData } from '@stacksjs/iconify-core'

export const align: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 7H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m-8 4H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m8 8H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m-8-4H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M19 14.666a1 1 0 0 1-1-1v-3.333a1 1 0 0 1 1.64-.768l2 1.667a1 1 0 0 1 0 1.536l-2 1.667a1 1 0 0 1-.64.231\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default align
